import * as React from 'react'
import { Box, Absolute, BoxProps } from '../box'
import { getPosition } from '../../utils/layout'

interface ZStackProps extends BoxProps {
    interactive?: boolean
}

const ZStack: React.FC<ZStackProps> = (props: any): React.ReactElement => {
	const {
		children,
		interactive,
		...rest
	} = props

	const styledChildren = React.Children.map(children, (child: any) => {
		if (child) {
			const childProps: any = {...child.props} || {}
			const containerProps: any = {}

			// add position properties to the absolute container
			const posProps = ['pos', 'position', 'top', 'right', 'bottom', 'left', 'zIndex']
			posProps.forEach((prop) => {
				if (undefined !== childProps[prop]) {
					containerProps[prop] = childProps[prop]
					childProps[prop] = 'auto'
				}
			})

			if (childProps.anchor) {
				const { anchor, width, height } = childProps
				const pos = getPosition(anchor)
				Object.keys(pos).forEach((key) => {
					containerProps[key] = pos[key]
					if (key === 'transform') {
						delete childProps[key]
					} else {
						childProps[key] = 'auto'
					}
				})

				if (width) {
					containerProps.width = width
				}
				if (height) {
					containerProps.height = height
				}

				if (anchor === 'fill') {
					if (!width) {
						childProps.width = '100%'
					}
					if (!height) {
						childProps.height = '100%'
					}
				} else if (anchor === 'fill-x' && !width) {
					childProps.width = '100%'
				} else if (anchor === 'fill-y' && !height) {
					childProps.height = '100%'
				}
			}

			return (
				<Absolute {...containerProps} interactive={interactive}>
					{React.cloneElement(child, childProps)}
				</Absolute>
			)
		}
		return child
	})

	rest.children = styledChildren
	// rest.position = rest.position || 'relative'
	rest.position = rest.position || 'relative'

	return (
		<Box {...rest} />
	)
}

export { ZStackProps }

export default ZStack
